export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg font-bold text-background-50 mb-4">51爆料网</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              51爆料网是国内领先的黑料深扒与内幕消息聚合平台。以"黑料不打烊"为核心理念，每日更新51爆料黑料、51黑料爆料等热门内容，黑料大全每周汇总，致力为吃瓜群众提供最全最深的内幕消息与负面爆料。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">快捷导航</h3>
            <ul className="space-y-2">
              <li><a href="#hero" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</a></li>
              <li><a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors">深度深扒</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors">热门黑料</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors">吃瓜指南</a></li>
              <li><a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors">我要爆料</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">话题分类</h3>
            <ul className="space-y-2">
              <li><a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors">明星黑历史</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors">网红翻车</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors">商业丑闻</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors">社会热点</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors">官场黑幕</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">合作伙伴</h3>
            <div className="grid grid-cols-3 gap-3">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="aspect-square bg-background-800 rounded-md flex items-center justify-center">
                  <span className="text-xs text-background-500">合作伙伴</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2019-2026 51爆料网. 本站内容均来自用户投稿与公开信息整理，不代表本站立场。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors">用户协议</a>
            <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}